import {createFlexAtom} from './utils';

const config = createFlexAtom('column');

export default config;
